import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getManageAreaTaxLocations: build.query({
      query: (args) => {
        const { page, perPage, searchParams = '', status } = args || {};
        const params = [
          `perPage=${perPage || DEFAULT_PER_PAGE}`,
          `page=${page || DEFAULT_PAGE}`,
          `status=${status || 'active'}`,
        ].join('&');

        return `${apiUrl.manageAreaTaxLocations}?${params}${searchParams ? `&${searchParams}` : ''}`;
      },
      transformResponse: (response) => ({
        areaTaxLocations: response?.data || [],
        pagination: response?.pagination,
      }),
      providesTags: ['ManageAreaTaxLocations'],
    }),
    getManageAreaTaxLocationById: build.query({
      query: (id) => `${apiUrl.manageAreaTaxLocations}/${id}`,
      transformResponse: (response) => response?.data,
      providesTags: (result, error, id) => [{ type: 'ManageAreaTaxLocation', id }],
    }),
    createManageAreaTaxLocation: build.mutation({
      query: (data) => ({
        url: `${apiUrl.manageAreaTaxLocations}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ManageAreaTaxLocations'],
    }),
    updateManageAreaTaxLocation: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `${apiUrl.manageAreaTaxLocations}/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: (result, error, { id }) => ['ManageAreaTaxLocations', { type: 'ManageAreaTaxLocation', id }],
    }),
    deleteManageAreaTaxLocation: build.mutation({
      query: (id) => ({
        url: `${apiUrl.manageAreaTaxLocations}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ManageAreaTaxLocations'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetManageAreaTaxLocationsQuery,
  useLazyGetManageAreaTaxLocationsQuery,
  useGetManageAreaTaxLocationByIdQuery,
  useCreateManageAreaTaxLocationMutation,
  useUpdateManageAreaTaxLocationMutation,
  useDeleteManageAreaTaxLocationMutation,
} = extendedApi;
